import * as React from 'react';
import { navigate } from '~/router';

import BaseOrgLocationListLayout from './BaseOrgLocationListLayout';
import LocationCreatePopup from '../containers/locations/LocationCreatePopup';


export default (params) => {
  return BaseOrgLocationListLayout(
    <LocationCreatePopup />
  );
};
